import { jsxs, jsx } from "react/jsx-runtime";
const SplitViewIcon = (props) => /* @__PURE__ */ jsxs("svg", { ...props, viewBox: "0 0 1024 1024", children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M144 560L144 864C144 872.8 151.2 880 160 880H864C872.8 880 880 872.8 880 864V560C880 551.2 872.8 544 864 544H160C151.2 544 144 551.2 144 560ZM212 612V812H812V612H212Z"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M144 160L144 464C144 472.8 151.2 480 160 480L864 480C872.8 480 880 472.8 880 464V160C880 151.2 872.8 144 864 144H160C151.2 144 144 151.2 144 160ZM212 212L212 412L812 412V212H212Z"
    }
  )
] });
export {
  SplitViewIcon
};
